import React from 'react';

const RadioButtonOption = ({ name, value, selected, label }) => (
    <div className="radio-button">
        <input type="radio" id={value} name={name} value={value} checked={selected} />
        <label className="login-radio" htmlFor={value}>
            {label}
        </label>
    </div>
);

RadioButtonOption.propTypes = {
    name: React.PropTypes.string.isRequired,
    value: React.PropTypes.node.isRequired,
    label: React.PropTypes.string.isRequired,
    selected: React.PropTypes.bool.isRequired,
};

RadioButtonOption.displayName = 'RadioButtonOption';

export default RadioButtonOption;



// WEBPACK FOOTER //
// ./src/components/Inputs/RadioButton/RadioButtonOption.jsx